import script from "./Directors.vue?vue&type=script&setup=true&lang=js"
export * from "./Directors.vue?vue&type=script&setup=true&lang=js"

import "./Directors.vue?vue&type=style&index=0&id=e5467a72&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5467a72"]])

export default __exports__